import React from "react";
import PropTypes from "prop-types";
import PilarContainer from "./styles/Pilar.style";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";

function Pilar({ image, title, description, link, reference, pilarText }) {
  return (
    <PilarContainer>
      <img className="pilar-image" src={image} alt={title}></img>
      <h2 className="pilar-title">{title}</h2>
      <p className="pilar-description">{description}</p>
      {link && (
        <Button className="pilar-button" href={link} variant="contained">
          {pilarText}
        </Button>
      )}
      {reference && (
        <Link className="pilar-button" to={reference}>
          <Button variant="contained">{pilarText}</Button>
        </Link>
      )}
    </PilarContainer>
  );
}

Pilar.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  link: PropTypes.string,
  reference: PropTypes.string
};

export default Pilar;
